import type { FunctionComponent, MouseEvent } from 'react'
import React from 'react'
import { JumplinksInline as SBJumplinksInline } from '@which/seatbelt'

import { useFeatureIsOn } from '@growthbook/growthbook-react'

export const JumplinksInline: FunctionComponent<Props> = ({ links = [], className }) => {
  const isStickyHeaderEnabled = useFeatureIsOn('WHC-1475-sticky-header')

  if (links.length === 0) {
    return null
  }

  return (
    <SBJumplinksInline className={className} items={getMappedLinks(links, isStickyHeaderEnabled)} />
  )
}

///////// IMPLEMENTATION /////////

const handleClick = (event: MouseEvent, id: string, isStickyHeaderEnabled: boolean): void => {
  event.preventDefault()

  const scrollTarget = document.getElementById(id)

  if (scrollTarget) {
    const scrollPos = window.scrollY + scrollTarget.getBoundingClientRect().top

    window.scrollTo({
      top: scrollPos - (isStickyHeaderEnabled ? 120 : 0),
      behavior: 'smooth',
    })
    window.history.pushState(null, '', `#${id}`)
  }
}

const getMappedLinks = (links: JumpLink[], isStickyHeaderEnabled: boolean) =>
  links.map(({ prefix = '', id, label, slug = '' }) => {
    let destinationId: string

    if (slug) {
      destinationId = slug
    } else {
      destinationId = prefix ? `${prefix}-${id}` : `${id}`
    }

    return {
      onClick: (event: MouseEvent<HTMLAnchorElement>) => {
        handleClick(event, destinationId, isStickyHeaderEnabled)
      },
      text: label,
    }
  })

export type JumpLink = {
  id: number | string
  label: string
  prefix?: string
  slug?: string
}

type Props = {
  links: JumpLink[]
  className?: string
}
